import './App.scss';
import { Route, Routes } from 'react-router-dom';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Login } from './components/authentication/Login';
import { AuthorizeUser } from './components/authentication/AuthorizeUser';
import { Layout } from './components/layout/Layout';
import { ReportDashboard } from './components/report-dashboard/ReportDasboard';
import { Dashboard } from './components/dashboard/Dashboard';
import { Logout } from './components/authentication/Logout';
import { PermissionsGate } from './components/authentication/PermissionsGate';

import { AppDispatch, authSlice, RootState } from './redux/internal';
import { SliceCallState } from './redux/sliceCallState';

//import { initializeGoogleAnalytics } from './utils/google-analytics';

export const App = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { token, loading } = useSelector((state: RootState) => state.auth);
  //const { decodedToken } = useSelector((state: RootState) => state.authReducer);

  useEffect(() => {
    if (!token && loading === SliceCallState.pending) {
      dispatch(authSlice.actions.getDataFromLocalStorage());
    }
    else {
      //initializeGoogleAnalytics(decodedToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, loading, token]);

  return (
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route path='login' element={<Login />} />
        <Route path='logout' element={<Logout />} />
        <Route path='authorizeUser' element={<AuthorizeUser />} />
        <Route path='*' element={<span>Page not found.</span>} />

        <Route
          index={true}
          element={
            <PermissionsGate>
              <Dashboard />
            </PermissionsGate>
          }
        />
        <Route
          path='dashboard'
          element={
            <PermissionsGate>
              <Dashboard />
            </PermissionsGate>
          }
        />
        <Route
          path=':categoryId/:reportId'
          element={
            <PermissionsGate>
              <ReportDashboard />
            </PermissionsGate>
          }
        />
      </Route>
    </Routes>
  );
};
